import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import NavigationBar from "../../Components/Navigation_Bar/NavigationBar";
import Home from "../Home/Home";
import Designs from "../Designs/Designs";
import About from "../About/About";
import ContactUs from "../Contact_Us/ContactUs";
import { useMediaQuery } from "@react-hook/media-query";
import Ecard from "../Ecard/Ecard";
import Layout from "../../Components/Layout/Layout";
const MainScreen = () => {
  const isSmallScreen = useMediaQuery("only screen and (max-width > 670px)");

  return (
    <BrowserRouter>
      <div
        className={`lg:overflow-hidden bg-background ${
          isSmallScreen ? `w-[100%]` : ""
        } w-screen`}
        style={{ minHeight: "100vh" }}
      >
        {/* <div className=' sticky top-0'> */}
        {/* <NavigationBar /> */}
        <Routes>
          <Route exact path="/" element={<Layout />}>
            {/* <Route path="/" element={<NavigationBar />}/> */}
            <Route index element={<Home />} />
            <Route path="Designs" element={<Designs />} />
            <Route path="About" element={<About />} />
            <Route path="ContactUs" element={<ContactUs />} />
          </Route>
          <Route path="ecard" element={<Ecard />} />
        </Routes>
        {/* </div> */}
      </div>
    </BrowserRouter>
  );
};

export default MainScreen;
